import { createReducer } from '@reduxjs/toolkit';
import { apiRequestSuccess } from 'services/api/api.actions';
import { inviteFriendEndpoint } from 'services/invite/invite.config';
import {
  InviteFriendsResponse,
  ResultCheck,
} from 'services/invite/invite.types';

type InviteState = {
  resultCheck?: ResultCheck;
  name?: string;
  surname?: string;
  signature?: string;
  email?: string;
};

const initialState: InviteState = {};

const inviteReducer = createReducer(initialState, (builder) =>
  builder.addCase(apiRequestSuccess, (state, action) => {
    const { payload } = action;

    if (payload.resourceId === inviteFriendEndpoint) {
      const response: InviteFriendsResponse = payload.response.data;

      state.resultCheck = response.resultCheck;
      state.name = response.name;
      state.surname = response.surname;
      state.signature = response.signature;
      state.email = response.email;
      return;
    }
  }),
);

export default inviteReducer;
